var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46997 4.5303C6.17697 4.2373 6.17697 3.76226 6.46997 3.46926L9.46997 0.469262C9.76297 0.176262 10.238 0.176262 10.531 0.469262L13.531 3.46926C13.824 3.76226 13.824 4.2373 13.531 4.5303C13.385 4.6763 13.193 4.75027 13.001 4.75027C12.809 4.75027 12.617 4.6773 12.471 4.5303L10.751 2.81033V8.00027C10.751 8.41427 10.415 8.75027 10.001 8.75027C9.58698 8.75027 9.25098 8.41427 9.25098 8.00027V2.8113L7.53101 4.53127C7.23701 4.82327 6.76297 4.8233 6.46997 4.5303ZM15 7.25027C14.586 7.25027 14.25 7.58627 14.25 8.00027C14.25 8.41427 14.586 8.75027 15 8.75027C16.792 8.75027 18.25 10.2083 18.25 12.0003V13.0003C18.25 14.7923 16.792 16.2503 15 16.2503H5C3.208 16.2503 1.75 14.7923 1.75 13.0003V12.0003C1.75 10.2083 3.208 8.75027 5 8.75027C5.414 8.75027 5.75 8.41427 5.75 8.00027C5.75 7.58627 5.414 7.25027 5 7.25027C2.381 7.25027 0.25 9.38127 0.25 12.0003V13.0003C0.25 15.6193 2.381 17.7503 5 17.7503H15C17.619 17.7503 19.75 15.6193 19.75 13.0003V12.0003C19.75 9.38127 17.619 7.25027 15 7.25027ZM16 12.0003C16 11.4483 15.552 11.0003 15 11.0003C14.448 11.0003 14 11.4483 14 12.0003C14 12.5523 14.448 13.0003 15 13.0003C15.552 13.0003 16 12.5523 16 12.0003Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.f6643c97456b4f7df796dbdb6817c087.svg";
export { ForwardRef as ReactComponent };